module.exports = __webpack_public_path__ + "img/security-audit-img-6.4079da0c.webp";